import { IPrice } from "../../interfaces/IPrice"
import { IProduct } from "../../interfaces/IProduct"

/**
 * Retrieves the lowest price tier for a given product and currency.
 * @param product - The product to retrieve the price tier for.
 * @param currency - The currency.
 * @returns lowest Product of that currency.
 */
export function getPricesForHighestContactTier(product: IProduct, currency: string | undefined): IPrice | undefined {
    // for free products, get the first currency match regardless of contact tier
    if (product.prices[0]?.metadata?.category === "free") {
        return product.prices.find((price: IPrice) => price.currency === currency)
    }
    const highestPriceForCurrency = product.prices
        .filter(price => price.currency === currency)
        .reduce((max: IPrice, obj: IPrice) => {
            return obj.unit_amount > max.unit_amount ? obj : max
        })
    return highestPriceForCurrency
}